export default {
  employees: "Кассирлер",
  noCreatedYet: "Кассирлер азырынча түзүлгөн жок",
  downloadAppRCKassa: "RC KASSA тиркемесин жүктөө",
  downloadRCKassa: "RC KASSAны жүктөө",
  addingEmployee: "Кассир кошуу",
  toCreateEmployeeNeedPoint:
    "Кассир түзүү үчүн кеминде бир соода нүктөсү керек",
  secondName: "Кассирдин фамилиясы",
  firstName: "Кассирдин аты",
  toTradingPoints: "Соода нүктөлөрүнө",
  uWantToDeleteEmployee: "Кассирди жок кылгыңыз келеби?",
  personName: "Фамилиясы жана Аты",
  blockAccess: "Кирүүгө бөгөт коюу",
  openAccess: "Ачуу мүмкүнчүлүгү",

  employeeScore: "Кассирлерге баллдар",
  points: "балл",
  debiting: "Чыгаруу",
  accrual: "Кошуу",

  enterPointsAmount:
    "Кардарларга баллдарды эсептөө операцияларын жүргүзгөнү үчүн кассирлер ала турган упайлардын санын киргизиңиз",
  forRealClientsOperations: "Бар болгон кардарлардын операциялары үчүн",
  forNewClientsOperation: "Жаңы кардарлардын операциялары үчүн",
  toSetPointsNeedBuyTariff:
    "Кассирлерге упайларды белгилөө үчүн «Промо» же «Про+» тарифин сатып алуу керек",
};
